import { useParams } from "react-router-dom";
import { SERVICES } from "@/lib/siteData";
import { usePageMeta, NOT_FOUND_META } from "@/lib/pageMeta";
import { ServiceHero } from "@/components/service/ServiceHero";
import { ServiceIdealFor } from "@/components/service/ServiceIdealFor";
import { ServiceGallery } from "@/components/service/ServiceGallery";
import { PendingSection } from "@/components/PendingSection";
import { NotFound } from "@/pages/NotFound";

// One template for all four service pages (25:11, 30:100, 30:152, 30:206) —
// they share their layout exactly and differ only in copy.
//
// Only Brand Care's copy has been transcribed so far. The other three render the
// same template with the copy they have and announce what is missing, rather than
// pretending to be finished.
export const ServicePage = () => {
    const { slug } = useParams();
    const service = SERVICES.find((entry) => entry.slug === slug);

    // Above the guard: usePageMeta is a hook, so it runs on every render — and
    // an unknown slug should carry the 404's metadata, not the last service's.
    usePageMeta(
        service
            ? {
                  title: service.name,
                  // The tagline alone is a quote; the first body line says what
                  // the service is. Together they read as a real description.
                  description: [service.tagline, service.body?.[0]].filter(Boolean).join(" "),
                  path: `/servicos/${service.slug}`,
              }
            : NOT_FOUND_META,
    );

    if (!service) return <NotFound />;

    const hasCopy = Boolean(service.body?.length);

    return (
        <>
            <ServiceHero service={service} />
            {hasCopy ? (
                <ServiceIdealFor service={service} />
            ) : (
                <PendingSection
                    title={service.name}
                    figmaNode={service.figmaNode}
                    note="O layout desta página já é o definitivo — falta transcrever os textos deste serviço do Figma (descrição e a lista de “Ideal para empresas que desejam”)."
                />
            )}
            <ServiceGallery />
        </>
    );
};
